/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { nameof } from "../../../Basis/Utils/AnyUtil";
import IZusatzfeldWert from "../Commands/IZusatzfeldWert";

export default ZusatzfeldType;

type ZusatzfeldType = "GANZZAHL" | "DEZIMALZAHL" | "PROZENT" | "DATUMZEIT" | "TEXT" | "RICHTEXT" | "CHECKBOX" | "AUSWAHL" | "MEHRFACHAUSWAHL";

export class ZusatzfeldTypen {
    public static readonly ganzzahl: ZusatzfeldType = "GANZZAHL";
    public static readonly dezimalzahl: ZusatzfeldType = "DEZIMALZAHL";
    public static readonly prozent: ZusatzfeldType = "PROZENT";
    public static readonly datumzeit: ZusatzfeldType = "DATUMZEIT";
    public static readonly text: ZusatzfeldType = "TEXT";
    public static readonly richtext: ZusatzfeldType = "RICHTEXT";
    public static readonly checkbox: ZusatzfeldType = "CHECKBOX";
    public static readonly auswahl: ZusatzfeldType = "AUSWAHL";
    public static readonly mehrfachauswahl: ZusatzfeldType = "MEHRFACHAUSWAHL";
}

export const FELDER: { [k in ZusatzfeldType]: string } = {
    "TEXT": nameof<IZusatzfeldWert>("string"),
    "AUSWAHL": nameof<IZusatzfeldWert>("string"),
    "RICHTEXT": nameof<IZusatzfeldWert>("string"),
    "GANZZAHL": nameof<IZusatzfeldWert>("integer"),
    "DEZIMALZAHL": nameof<IZusatzfeldWert>("decimal"),
    "PROZENT": nameof<IZusatzfeldWert>("decimal"),
    "CHECKBOX": nameof<IZusatzfeldWert>("boolean"),
    "DATUMZEIT": nameof<IZusatzfeldWert>("dateTime"),
    "MEHRFACHAUSWAHL": nameof<IZusatzfeldWert>("stringArray"),
} as const;